module.exports = __webpack_public_path__ + "static/img/xxgzh.dd733c30.jpg";